module.exports = __webpack_public_path__ + "static/media/logo-cbg-corporate.ffe51474.svg";